import commonMixin from '../mixins/_common';
import flashMessageMixin from '../mixins/_flash_messages';

/**
 * テンプレート選択コンポーネント
 */
export default {
    name: 'TemplateSelecter',
    template: '#template_selecter_template',
    data () {
        return {
            // 全テンプレート一覧
            templates: [],
            // 指定テンプレートindex
            template_index: null,
        };
    },
    props: {
        // 呼び出し元ページ
        template_type: {
            type: String,
            require: false,
            validator: function (value) {
                return ['build_store', 'item', 'custom_page'].indexOf(value) !== -1;
            }
        },
        // プレビューボタンを表示するか
        is_preview_enable: {
            type: Boolean,
            require: false,
            default: true
        }
    },
    computed: {
        // 全テンプレート取得しているか
        hasTemplates: function () {
            return (this.templates.length > 0);
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    created: function () {
        this.getTemplates();
    },
    watch: {
        template_type: function () {
            this.getTemplates();
        }
    },
    emits: ['preview', 'select-template-data', 'failed'],
    methods: {
        // リクエストURL
        getUrl: function () {
            const paths = location.pathname.split('/');
            const path = (this.template_type) ? this.template_type : paths[1];
            return '/' + path + '/get_templates';
        },
        // 全テンプレートを取得
        getTemplates: async function () {
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const url = this.getUrl();
                const response = await axios.get(url);
                if (response.data.status == 'OK') {
                    if (response.data.data) {
                        // 全テンプレートセット
                        this.templates = response.data.data;
                        // 一つ目のindexを初期で選択する
                        this.template_index = 0;
                        message = '';
                    }
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.emitFailed();
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 指定のテンプレートデータを取得
        getTemplate: function (index) {
            if (this.hasTemplates && typeof this.templates[index] !== 'undefined') {
                let template =  _.cloneDeep(this.templates[index]);
                return template;
            }
            return {};
        },

        // -------------------------
        // emit
        // -------------------------

        // 選択されたテンプレートを親へ通知
        emitShowPreview: function (index) {
            this.$emit('preview', this.getTemplate(index));
        },
        // 選択されたテンプレートを親へ通知
        emitSelectTemplateData: function () {
            this.$emit('select-template-data', this.getTemplate(this.template_index).data);
        },
        // エラーがあったことを親へ通知
        emitFailed: function () {
            this.$emit('failed');
        },
    }
};